import UpsideDownText from './UpsideDownText.vue';

export default UpsideDownText;
